import React, { useEffect, useState } from 'react';

// MUI Components
import {
  Box,
  Typography,
  IconButton,
  Dialog,
  DialogContent,
  CircularProgress,
} from '@mui/material';
import { styled } from '@mui/material/styles';

// Icons
import { CloseModalIcon } from '~/assets/images';

// Styled Dialog
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const QrViewModal = ({ open, onClose, selectedQrCode }) => {
  const [isImageLoading, setIsImageLoading] = useState(true);

  const qrImageSrc = selectedQrCode?.qrCodeJson?.qrImagePath;

  useEffect(() => {
    if (open && qrImageSrc) {
      setIsImageLoading(true);
    } else {
      setIsImageLoading(false);
    }
  }, [open, qrImageSrc]);

  return (
    <BootstrapDialog
      aria-labelledby="customized-dialog-title"
      open={open}
      className="olcModal"
      PaperProps={{
        sx: {
          width: '488px',
          maxWidth: '100%',
          borderRadius: '16px',
        },
      }}
    >
      <DialogContent className="modalContent" style={{ borderRadius: '16px' }}>
        <Box className="modalHeader">
          <Typography gutterBottom className="viewQRModalTitle">
            {selectedQrCode?.qrCodeJson?.utm_campaign_name || 'N/A'}
            <span className="viewQRModalStatus">({selectedQrCode?.status || 'N/A'})</span>
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            className="crossIcon"
            disableRipple
            disableFocusRipple
            disableTouchRipple
            sx={{
              '&:hover': {
                backgroundColor: 'transparent',
              },
            }}
          >
            <img src={CloseModalIcon} alt="close" />
          </IconButton>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '0px 40px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              width: '260px',
              height: '260px',
              flexShrink: '0',
              position: 'relative',
            }}
          >
            {isImageLoading && (
              <CircularProgress
                size={48}
                sx={{
                  position: 'absolute',
                  color: '#ed5c2f',
                }}
              />
            )}
            {qrImageSrc && (
              <img
                src={qrImageSrc}
                alt="QR Code"
                className="downloadTableIcon"
                height={225}
                width={225}
                style={{ display: isImageLoading ? 'none' : 'block' }}
                onLoad={() => setIsImageLoading(false)}
                onError={() => setIsImageLoading(false)}
              />
            )}
          </Box>
        </Box>
      </DialogContent>
    </BootstrapDialog>
  );
};

export default QrViewModal;
